module.exports = __webpack_public_path__ + "img/IMG_8565.71d6f571.jpeg";